var app = angular.module('directives.applePay');

app.directive('applePay', [
    'configs',
    '$state',
    'PortalApi',
    'ClientCards',
    'AmountCommission',
    function(configs, $state, PortalApi, ClientCards, AmountCommission) {
        return {
            restrict: "E",
            scope: {
                onlyGetCardData: '=',
                isDisabled: '=',
                isInvalid: '=',
                onInvalidClick: '&'
            },
            template: require('../templates/index.html'),
            controller: 'applePayCtrl',
            init: function (scope) {
            },
            link: function(scope, element, attrs, ctrl) {
            }
        }

    }
]);

app.controller('applePayCtrl', function ($rootScope, $scope, Pay, $timeout, PortalApi, ClientCards, $window, AmountCommission) {
    $scope.pay = Pay;

    $scope.merchantIdentifier = 'merchant.ua.com.payhub';
    $scope.isApplePayAvailable = false;

    $timeout(function () {
        if ($window && $window.ApplePaySession) {
            $window.ApplePaySession.canMakePaymentsWithActiveCard($scope.merchantIdentifier).then(function(canMakePayments) {
                if (canMakePayments) {
                    $scope.isApplePayAvailable = true;
                    ClientCards.data.applePayAvailable = true;
                } else {
                    $scope.isApplePayAvailable = false;
                    ClientCards.data.applePayAvailable = false;
                }

                $scope.$apply();
            });
        }
    }, 3000);

    $scope.applePay = function () {
        if (!$window || !$window.ApplePaySession) {
            return;
        }

        if($scope.isInvalid) {
            return $scope.onInvalidClick();
        }

        // Define ApplePayPaymentRequest
        var request = {
            'countryCode': 'UA',
            'currencyCode': 'UAH',
            'merchantCapabilities': [
                'supports3DS',
            ],
            'supportedNetworks': [
                'visa',
                'masterCard',
            ],
            'total': {
                'label': $scope.pay.service.name,
                'type': 'final',
                'amount': +$scope.pay.amountWithCommission || +$scope.pay.amountInput || 0,
            },
        };

        // Create ApplePaySession
        var session = new $window.ApplePaySession(3, request);
        session.onvalidatemerchant = function(event) {
            // Call your own server to request a new merchant session.
           PortalApi.applePayMerchantValidation(event.validationURL, $window.location.hostname).then(function (data) {
                session.completeMerchantValidation(data);
           });
        };

        session.onpaymentauthorized = function(event) {
            // Define ApplePayPaymentAuthorizationResult
            
            console.log('APAY data', event.payment);//TODO: Delete
            var result = {
                'status': ApplePaySession.STATUS_SUCCESS,
            };

            session.completePayment(result);
            ClientCards.setGAPay('APPLE_PAYLOAD', JSON.stringify(event.payment.token));

            if($scope.onlyGetCardData) {
                $timeout(function () {
                    ClientCards.gaPayData.cardPaymentNetwork = event.payment.token.paymentMethod.network;
                    ClientCards.gaPayData.cardMaskedNumber = event.payment.token.paymentMethod.displayName.slice(-4);
                    AmountCommission.countAmount();
                }, 500);
            } else {
                if($rootScope.servicePage) {
                    $scope.pay.confirmServicePayment(true);
                } else {
                    $scope.pay.createPayment(true);
                }
            }
        };

        session.oncancel = function(event) {
            console.log('oncancel event', event); // TODO: Delete
        };

        session.begin();
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/applePay/directives/applePay.js
 ** module id = 120
 ** module chunks = 1
 **/